import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
// import {Button} from "react-bootstrap";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// import Link from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Redirect } from "react-router";
import fontb from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
import logo1 from "../../assets/img/etela.png"
import logo2 from "../../assets/img/ihcs.png"
import { Row ,Col} from 'react-bootstrap';
import Grid from '@material-ui/core/Grid';
// import { ThemeProvider } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// import { Calendar, DatePicker } from 'react-persian-datepicker';
// import {DatePicker} from 'react-persian-datepicker'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import {DateInput, DateInputSimple, DateTimeInput, DateTimeInputSimple} from 'react-hichestan-datetimepicker';
import { StylesProvider, ThemeProvider } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";
import { jssPreset } from "@material-ui/core/styles";
import RTL from "layouts/Dashboard";
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme4 = createMuiTheme({
  typography: { useNextVariants: true },
  direction: "rtl"
});
let theme2 = createMuiTheme();
theme2.typography.h3 = {
  fontSize: '1.2rem',
  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
  [theme2.breakpoints.up('md')]: {
    fontSize: '2.5rem',
  },
};

let fontConfig = {

  file: [
    {
      fontFamily: 'Bangers',
      fontStyle:  'normal',
      fontWeight: 400,
      // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
      file: fontb,
      fontType: 'truetype',
      fileLocal: 'Bangers Regular'
    },
    
  
  ]
}
 class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // UserName: "",
      Password: "",
      Password2:"",
      Email:"",
      Name:"",
      FamilyName:"",
      Job:"",
      Education:"",
      FieldStudy:"",
      PhoneNumber:"",
      Sex:"",
      token: "",
      Date:"",
      signup:false,
      selectedOption: null,
      classes: makeStyles((theme) => ({
        paper: {
          marginTop: theme.spacing(8),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "rgb(179,7,83)",
        },
        avatar: {
          color: "#3f51b5",
          // margin: theme.spacing(1),
          // marginLeft:'1000px',
          // backgroundColor: '#f44336',
        },
        form: {
          width: "100%", // Fix IE 11 issue.
          marginTop: theme.spacing(1),
        },
        submit: {
          margin: theme.spacing(3, 0, 2),
        },
      })), 
    };
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword1 = this.handleChangePassword1.bind(this);
    this.handleChangePassword2 = this.handleChangePassword2.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeFamilyName = this.handleChangeFamilyName.bind(this);
    this.handleChangeJob = this.handleChangeJob.bind(this);
    this.handleChangeEducation = this.handleChangeEducation.bind(this);
    this.handleChangeFieldStudy = this.handleChangeFieldStudy.bind(this);
    this.handleChangePhoneNumber = this.handleChangePhoneNumber.bind(this);
    this.handleChangeSex = this.handleChangeSex.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
  
  }

  handleChangeEmail(event) {
    this.setState({ Email: event.target.value });
  }

  handleChangePassword1(event) {
    this.setState({ Password: event.target.value });
  }

  handleChangePassword2(event) {
    this.setState({ Password2: event.target.value });
  }
  handleChangeName(event) {
    this.setState({ Name: event.target.value });
  }
  handleChangeFamilyName(event) {
    this.setState({ FamilyName: event.target.value });
  }
  handleChangeJob(event) {
    this.setState({ Job: event.target.value });
  }
  handleChangeEducation(event) {
    this.setState({ Education: event.target.value });
  }
  handleChangeFieldStudy(event) {
    this.setState({ FieldStudy: event.target.value });
  }
  handleChangePhoneNumber(event) {
    this.setState({ PhoneNumber: event.target.value });
  }
  handleChangeSex(event) {
    console.log(event.target.value)
    this.setState({ Sex: event.target.value });
  }
  // handleChange = selectedOption => {
  //   this.setState({ selectedOption });
  //   console.log(`Option selected:`, selectedOption);
  // };
  handleChangeDate(event) {
    console.log(event.target.value)
    this.setState({ Date: event.target.value });
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
   
    // const { selectedOption } = this.state;
    return (
      
     
   
    
         
      // <BrowserView>
      <StylesProvider jss={jss}>
      <ThemeProvider theme={theme4}>

           <div style={{  display: 'flex', justifyContent: "center",marginTop:'5%'}}>
       
        <div style={{width:"60%",border:'1px solid black',borderRadius:"1%"}}>
      <Grid Container fluid  style={{justifyContent: 'row', display: "flex",backgroundColor: "rgb(44,71,76)" ,width:"100%"}}>
      <Grid item xs={4} sm={4} md={4} lg={4} >
      <img src={logo1} style={{width:'100%'}}/>
        </Grid>
        {/* <div style={{width:"15%",height:"10vh"}}> */}
        <Grid item xs={12} sm={12} md={12} lg={12} >
    <ThemeProvider theme={theme2} >
      <Typography variant="h3" style={{height:"30%", textAlign:"center", fontFamily:'Bangers',marginTop:"6%",color:"rgb(255,255,255)"}}> سامانه تحلیل مقالات علمی
</Typography>
    </ThemeProvider>
      
        </Grid>
        <Grid item xs={3} sm={3} md={3} lg={3} >
        <img  src={logo2} style={{width:'100%'}}/>
        </Grid>

        
          </Grid>
          <div style={{height:".001%",border:'1px solid black'}}>

          </div>
          <ThemeProvider theme={theme2} >
      <Typography variant="h3" style={{ textAlign:"center", fontFamily:'Bangers',marginTop:"5%"}}>               ثبت نام در سامانه                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
</Typography>
    </ThemeProvider>
        
      <Container  component="main" maxWidth="xs" style={{height:'auto'}}>
        <CssBaseline />
        <Button
              fullWidth
              
              className="button"
              style={{fontFamily:'Bangers',fontSize:20,width:"4%" ,backgroundColor: "rgb(44,71,76)",position: 'fixed', top: 0,
              left: 0,borderRadius:"5px",color:"rgb(255,255,255)" }}
              onClick={() => this.back()}
            >
              بازگشت  
            </Button>                                                                                                                                                                                                                                                             
        <div className={this.state.classes.paper} style={{marginTop:"1%",height:'auto'}}>
          
       
          <form className={this.state.classes.form} noValidate >
         
            {/* <TextField 
            required minLength={1}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="نام کاربری"
              name="email"
              autoComplete="email"
              onChange={this.handleChange}
              autoFocus
            /> */}
          {/* <Calendar
      // value={selectedDay}
      // onChange={setSelectedDay}
      locale="fa"
      shouldHighlightWeekends
    /> */}
    {/* <DatePicker calendarStyles /> */}
    {/* <DatePicker  const calendarS  tyles = {{
      calendarContainer: 'calendarContainer',
      dayPickerContainer: 'dayPickerContainer',
      monthsList: 'monthsList',
      daysOfWeek: 'daysOfWeek',
      dayWrapper: 'dayWrapper',
      selected: 'selected',
      heading: 'heading'
  }} /> */}
  
            <TextField 
              // direction='rtl'
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="نام"
              name="email"
              style={{direction:'rtl'}}
              autoComplete="email"
              onChange={this.handleChangeName}
              autoFocus
            />
            <TextField 

              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="نام خانوادگی"
              name="email"
              style={{direction:'rtl'}}
              autoComplete="email"
              onChange={this.handleChangeFamilyName}
              autoFocus
            />
                <TextField 
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              style={{direction:'rtl'}}
              label="ایمیل"
              name="email"
              autoComplete="email"
              onChange={this.handleChangeEmail}
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="رمز عبور"
              type="password"
              style={{direction:'rtl'}}
              id="password"
              onChange={this.handleChangePassword1}
              autoComplete="current-password"
            />
             <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              style={{direction:'rtl'}}
              // style={{textAlign:"right"}}
              name="password"
              label="تکرار رمز عبور"
              type="password"
              id="password"
              onChange={this.handleChangePassword2}
              autoComplete="current-password"
            />
               <TextField
            // dir="rtl"
            variant="outlined"
            id="standard-name"
            label="تاریخ تولد"
            onChange={this.handleChangeDate}
            value={this.state.Date}
            style={{width: '100%',marginTop:"5%"}}
            InputProps={{
              inputComponent: DateInput,
              inputProps: {},
            }}
          />
             <FormControl variant="outlined" style={{width:"100%",marginTop:"7%"}}>
        <InputLabel id="demo-simple-select-outlined-label">شغل</InputLabel>
        <Select
        // style={{direction:'rtl'}}
        style={{fontSize:15,direction:'rtl'}}
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          // value={age}
          onChange={this.handleChangeJob}
          label="Age"
        >
          {/* <MenuItem value=""> */}
            {/* <em>None</em> */}
          {/* </MenuItem> */}
          <MenuItem value={'دانشجو'}>دانشجو</MenuItem>
          <MenuItem value={'پژوهشگر آزاد'}>پژوهشگر آزاد</MenuItem>
          <MenuItem value={'عضو هیات علمی'} >عضو هیأت علمی</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" style={{width:"100%",marginTop:"7%"}}>
        <InputLabel id="demo-simple-select-outlined-label">میزان تحصیلات</InputLabel>
        <Select
        style={{fontSize:15,direction:'rtl'}}
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          // value={age}
          onChange={this.handleChangeEducation}
          label="Education"
        >
          {/* <MenuItem value=""> */}
            {/* <em>None</em> */}
          {/* </MenuItem> */}
          <MenuItem value={'کارشناسی'}>کارشناسی</MenuItem>
          <MenuItem value={'کارشناسی ارشد'}>کارشناسی ارشد</MenuItem>
          <MenuItem value={'دکتری تخصصی'} >دکتری تخصصی </MenuItem>
        </Select>
      </FormControl>
   
      <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="رشته تحصیلی"
              // type="password"
              style={{direction:'rtl'}}
              id="password"
              onChange={this.handleChangeFieldStudy}
              autoComplete="current-password"
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              style={{direction:'rtl'}}
              label="شماره تماس"
              // type="password"
              id="password"
              onChange={this.handleChangePhoneNumber}
              autoComplete="current-password"
            />
            <FormControl variant="outlined" style={{width:"100%",marginTop:"5%"}}>
        <InputLabel fullWidth required variant="outlined" margin="normal" >جنسیت</InputLabel>
        <Select
        style={{fontSize:15,direction:'rtl'}}
          // labelId="demo-simple-select-outlined-label"
          // id="demo-simple-select-outlined"
          // value={age}
          onChange={this.handleChangeSex}
          label="Age"
        >
          {/* <MenuItem value=""> */}
            {/* <em>None</em> */}
          {/* </MenuItem> */}
          <MenuItem value={'مرد'}>مرد</MenuItem>
          <MenuItem value={'زن'}>زن</MenuItem>
          {/* <MenuItem value={30} >دکتری تخصصی </MenuItem> */}
        </Select>
      </FormControl>
            <Button
              fullWidth
              
              className="button"
              style={{marginTop:"2%",fontFamily:'Bangers',fontSize:20 ,backgroundColor: "rgb(44,71,76)" ,color:"rgb(255,255,255)"}}
              onClick={() => this.sendSignUpData()}
            >
              ثبت نام  
            </Button>
          
            <div>{this.SignUpcheck()}</div>
            {/* <div>{this.check22()}</div> */}
            {this.state.back ?  <Redirect
          to={{
            pathname: "/",
           
          }}
        /> :null}
          </form>
        </div>
        <Box mt={8}>{/*<Copyright/>*/}</Box>
      </Container>
      </div>
      </div>
      </ThemeProvider>
    </StylesProvider>
      
    );
  }
  SignUp(){
    this.setState({
      signup:true
    })
  }
  back(){
    this.setState({
      back:true
    })

  }
  SignUpcheck(){
    if (this.state.token){

      return (
        // <BrowserRouter>
        <Redirect
          to={{
            pathname: "/",
           
          }}
        />
        // </BrowserRouter>
      );
  
    }


  }
  // ForgetPassword(){
  //   return (
  //     // <BrowserRouter>
  //     <Redirect
  //       to={{
  //         pathname: "/forgetpassword",
  //         state: {
  //           token: this.state.token,
  //           UserName: this.state.UserName,
  //         },
  //       }}
  //     />
  //     // </BrowserRouter>
  //   );


  // }
  // check22() {
  //   if (this.state.token) {
  //     // console.log("entered");
  //     return (
  //       // <BrowserRouter>
  //       <Redirect
  //         to={{
  //           pathname: "/dashboard/LDA",
  //           state: {
  //             token: this.state.token,
  //             UserName: this.state.UserName,
  //           },
  //         }}
  //       />
  //       // </BrowserRouter>
  //     );
  //   }
  // }

  sendSignUpData() {
    // ^[A-Za-z0-9_]+$
    if(this.state.Name.match(/^[A-Za-z0-9_]+$/)){
      alert("نام را به صورت فارسی وارد کنید.");
    }
    else if(this.state.FamilyName.match(/^[A-Za-z0-9_]+$/)){
      alert("نام خانوداگی را به صورت فارسی وارد کنید.");
    }
    else if(!this.state.Email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/)){
      alert("ایمیل را با فرمت درست وارد کنید.");
    }
    else if(!this.state.Password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/)){
      alert(".رمز باید شامل حداقل ۸ کاراکتر انگلیسی باشد که حداقل یک حرف وحداقل یک عدد داشته باشد");

    }
    else if(this.state.Password!==this.state.Password2){
      alert("رمزهای وارد شده یکسان نمی باشند");

    }else if(this.state.Date.length==0){
      alert("تاریخ تولد را وارد کنید");

    }else if(this.state.Name.length==0 ||this.state.FamilyName.length==0){
      alert("نام و نام خانوداگی را وارد کنید");

    }else if(this.state.FieldStudy.length==0){
      alert("رشته تحصیلی ﺭﺍ ﻭﺍﺭﺩ کﻥیﺩ");

    }else if(this.state.PhoneNumber.length==0){
      alert("شماره تماس را وارد کنید");

    }else if(this.state.Sex.length==0){
      alert("جنسیت ﺭﺍ ﻭﺍﺭﺩ کﻥیﺩ");

    }else if(this.state.Education.length==0){
      alert("تحصیلات ﺭﺍ ﻭﺍﺭﺩ کﻥیﺩ");

    }
    else{
     
      console.log(this.state.Email)
      console.log(this.state.Password)
      console.log(this.state.Date)
      console.log(this.state.Job)
      
      console.log(this.state.Education)
      console.log(this.state.Name)
      console.log(this.state.FamilyName)
      console.log(this.state.FieldStudy)
      console.log(this.state.PhoneNumber)
      console.log(this.state.Sex)
	//      fetch("http://conalysis.ihcs.ac.ir:8080/signup", {
	      fetch("http://conalysis.ihcs.ac.ir:8080/signup", {

        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Email: this.state.Email,
          Password: this.state.Password,
          Job:this.state.Job,
          PhoneNumber:this.state.PhoneNumber,
          Education:this.state.Education,
          Name:this.state.Name,
          FamilyName:this.state.FamilyName,
          FieldStudy:this.state.FieldStudy,
          Sex:this.state.Sex,
          Date:this.state.Date,
        }),
      }).then((response) => response.json())
        .then((responseJson) => {
          console.log(responseJson)
          if(responseJson.status=='block'){
            // alter("username or password is wrong") 
            alert("ایمیل در سیستم موجود است")
          }
          else{
  
            this.setState({
              token: 23,
            });
            alert("لینک تایید به ایمیل فرستاده شد")
          }
          // console.log(responseJson);
         
          // window.location.href="/dashboard";
          // return (<Link to="/dashboard"/>);
          // alert(responseJson);
        })
        .catch((error) => { 
          console.log(error);
        });


    }
    
   
  }
}
export default ReactFontFace(SignUp, fontConfig);
